import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from "../utils/axiosConfig";
import { Box, Button, Container, Paper, Typography, CircularProgress, Tooltip } from '@mui/material';
import { useAuth } from "../context/AuthContext"; // Import AuthContext

//import { handleApiError } from '../utils/apiErrorHandler';

const RegistrationConfirmationPage: React.FC = () => {
  const { confirmationId } = useParams<{ confirmationId: string }>();
  const { competitionId } = useParams<{ competitionId: string }>();
  const navigate = useNavigate();
  const { userRole } = useAuth(); // Get user role from AuthContext
  
  // Check if user is a helper
  const isHelper = userRole === 'helper';
  
  const [confirmation, setConfirmation] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [pdfUrl, setPdfUrl] = useState<string | null>(null);

  useEffect(() => {
    const fetchConfirmation = async () => {
      try {
        const response = await axios.get(`/api/registration-confirmations/id/${confirmationId}`);
        setConfirmation(response.data);
        
        // Sofort nach dem Laden der Bestätigungsdaten das PDF generieren
        await getPDF();
      } catch (error) {
        //handleApiError(error, 'Fehler beim Laden der Bestätigung.');
        setError('Die Bestätigung konnte nicht geladen werden.');
        setLoading(false);
      }
    };
    
    fetchConfirmation();
  }, [confirmationId]);
  
  const getPDF = async () => {
    try {
      /*
      // Generiere das PDF und erhalte es direkt als Blob
      const response = await axios.get(`/api/registration-confirmations/pdf/${confirmationId}`);
      
      // Erstelle eine Blob-URL aus der Antwort
      const pdfBlob = new Blob([response.data], { type: "application/pdf" });
      const url = URL.createObjectURL(pdfBlob);*/

      const response = await axios.get(`/api/registration-confirmations/pdf/${confirmationId}`, {
        responseType: 'blob'
      });
      
      // response.data ist bereits ein Blob, kein neuer Blob muss erstellt werden
      const url = URL.createObjectURL(response.data);

      setPdfUrl(url);
      setLoading(false);
    } catch (error) {
      //handleApiError(error, 'Fehler bei der PDF-Generierung.');
      setError('Das PDF konnte nicht erstellt werden.');
      setLoading(false);
    }
  };
  
  const handleSentRegistrationConfirmationMail = async () => {
    try {
      setLoading(true);
      
      // Weiterleitung zum E-Mail-Editor statt zur Übersicht
      //const confirmationId = confirmation._id.toString();
      navigate(`/orga/competition/${competitionId}/confirmation-registration/${confirmationId}/send-email`);
    } catch (error) {
      //handleApiError(error, 'Fehler beim Navigieren zum E-Mail-Editor.');
      setError('Die E-Mail-Seite konnte nicht geladen werden.');
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };
  
  const handleBack = () => {
    const compId = confirmation.competition._id.toString()
    // Navigiere zum Dashboard der Competition
    if (confirmation && confirmation.competition) {        
      navigate(`/orga/competition/${compId}`);
    } else {
      // Fallback, falls keine competition.id verfügbar ist
      navigate('/orga/competitions');
    }
  };
  
  if (loading) {
    return <div className="loading">Laden...</div>;
  }
  
  if (error) {
    return <div className="error">{error}</div>;
  }

  // Daten für die Breadcrumb-Navigation
  const breadcrumbData = {
    competitionName: confirmation.competition?.name || '',
    clubName: confirmation.club?.name || ''
  };
  
  return (
    <Container maxWidth="lg">      
      <Paper sx={{ p: 3 }}>
        <Typography variant="h5" gutterBottom>Meldebestätigung</Typography>
        
        <Box mb={2}>
          <Typography variant="h6">{confirmation.competition?.name}</Typography>
          <Typography variant="subtitle1">{confirmation.club?.name}</Typography>
        </Box>
        
        {pdfUrl && (
          <Box mb={3} sx={{ height: '70vh', border: '1px solid #ddd', borderRadius: '4px' }}>
            <iframe
              src={`${pdfUrl}#toolbar=0`}
              width="100%"
              height="100%"
              title="PDF Vorschau"
            />
          </Box>
        )}
        
        <Box display="flex" justifyContent="space-between">
          <Button 
            variant="outlined"
            onClick={handleBack}
          >
            Zurück
          </Button>
          
          {/* "Meldebestätigung absenden" Button nur anzeigen, wenn der Benutzer KEIN Helper ist */}
          {isHelper ? (
            <Tooltip title="Du hast keine Berechtigung, Meldebestätigungen zu versenden">
              <span>
                <Button 
                  variant="contained"
                  color="primary"
                  disabled={true}
                >
                  Meldebestätigung absenden
                </Button>
              </span>
            </Tooltip>
          ) : (
            <Button 
              variant="contained"
              color="primary"
              onClick={handleSentRegistrationConfirmationMail}
            >
              Meldebestätigung absenden
            </Button>
          )}
        </Box>
      </Paper>
    </Container>
  );
};

export default RegistrationConfirmationPage;